import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { HatoColumnKey } from "@/features/accounts/api/accountsApi";
import { Columns3 } from "lucide-react";
import { HATO_COLUMN_LABEL, HATO_COLUMN_ORDER, type HatoVisibleColumns } from "../hatoColumns";

type Props = {
  columns: HatoVisibleColumns;
  onToggle: (key: HatoColumnKey, visible: boolean) => void;
};

// Botón "Columnas" de la lista del Hato (spec columnas-hato §8). Cada toggle
// guarda al instante — el caller dispara la mutation de ui-preferences.
export function HatoColumnsDropdown({ columns, onToggle }: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Configurar columnas"
        data-testid="hato-columns-trigger"
        className="inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-app-border bg-app-surface px-4 py-2.5 font-medium text-[14px] text-app-ink-1 transition-colors hover:bg-app-surface-2 md:w-auto"
      >
        <Columns3 size={16} strokeWidth={2} />
        Columnas
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[12rem]">
        {HATO_COLUMN_ORDER.map((key) => (
          <DropdownMenuCheckboxItem
            key={key}
            checked={columns[key]}
            onCheckedChange={(checked) => onToggle(key, checked === true)}
            // Toggle rápido: mantener el menú abierto para configurar varias
            // columnas sin reabrirlo.
            onSelect={(e) => e.preventDefault()}
          >
            {HATO_COLUMN_LABEL[key]}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
